import React from 'react';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import Buy from './Buy';

function BuyIndex() {
  return (
    <div>
      <Navbar />
      <Buy />
      <Footer />
    </div>
  );
}

export default BuyIndex;
